import { BlockInstanceProps } from '../Block';
import ImageText from '../../components/ImageTexts';
import {
  ContentTypeEnum,
  BackgroundColorEnum,
} from '../../constants/cms-constants';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  { key: 'seoWeight', definition: controlOptionDefinitions.SEOWeightTypes },
])
class ImageTextsBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const seoWeight = controlOptions?.seoWeight;

    let mediaItem;
    blockContent.doQuery((content) => {
      mediaItem = content.getFirstOfType(ContentTypeEnum.MEDIAITEM);
    });

    return (
      <ImageText
        mainHeaderText={block?.header?.main}
        lightHeaderText={block?.header?.light}
        titleText={mediaItem.lightHeader}
        bodyText={mediaItem.bodyText}
        image={mediaItem.image}
        backgroundColor={backgroundColor}
        seoWeight={seoWeight}
      />
    );
  }
}

export default ImageTextsBlock;
